<template>
    <modal
        transition="nice-modal-fade"
        class="new-modal-default lead-interaction-add-sales"
        :name="modal_name"
        :delay="100"
        height="auto"
        :adaptive="true" 
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false">
        <div class="v-modal-content" style="border-radius: 15px;background-color: #fff !important;">
            <!-- Header Section -->
            <div class="v-modal-header">
                <div>
                    <!-- <span v-if="edit_product == true" class="v-modal-dialog-title v-modal-title text-uppercase">Edit Products</span> -->
                    <span class="v-modal-dialog-title v-modal-title text-uppercase">Product's Sales Info</span>
                </div>
                <div @click="hideAddSalesData()">
                    <span class="icon icon-close mr-2 text-white pointer close-left"></span>
                </div>
            </div>
            <!-- Content Body Section -->
            <div class="v-modal-body">
                <div class="fs-14 fw-500 p-2 bg-color mb-6">Product’s Sales Template Details</div>
                <div class="position-relative ml-1 mr-1">
                    <div class="row px-4">
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                            <span class="fs-14 fw-600 px-2 text-secondary text-capitalize" >
                                Product Name
                            </span>
                            <div class="d-flex align-items-center">
                                <div class="w-100"> 
                                    <input class="inputFieldNew mt-2" type="text" v-model="Product_name" disabled/>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-12" v-if="template_loader">
                            <div class="d-flex align-items-center justify-content-center w-100" v-if="template_loader">
                                <half-circle-spinner :animation-duration="1000" :size="30" color="#00448b" style="margin: 0 auto;" />
                            </div>
                        </div>
                        <div v-else class="col-lg-4 col-md-4 col-sm-12 mt-5" v-for="(sales, sales_index) in template_details.fields" :key="sales_index">
                            <div v-if="sales.field_type == 'input_field' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize" >
                                    {{sales.field_name}}
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <input class="inputFieldNew mt-2" :maxlength="50" :name="'sales_field'+sales_index" type="text" v-model="sales.value" :placeholder="'Enter ' + sales.field_name" />
                                    </div>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'dropdown_field' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect :name="'sales_field'+sales_index"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                            :searchable="true" open-direction="bottom" @select="$forceUpdate()"
                                            v-model="sales.value" :max-height="200" label="" id="ajaxnew"
                                            :options="sales.options" :placeholder="'Select ' + sales.field_name" />
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">{{sales.field_name}} Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'amount' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}({{currency}})
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <input :name="'sales_field'+sales_index" class="inputFieldNew mt-2" v-on:keypress="isNumber($event)" :maxLength="15" autocomplete="off" type="text" v-validate="{regex: /^-?\d+(?:\.\d?\d)?$/}" v-model="sales.value" placeholder="Enter Amount" />
                                    </div>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'checkbox' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}
                                </span>
                                <div class="d-flex justify-content-between align-items-center px-2">
                                    <el-checkbox-group class="refund-checkbox mt-4 w-100" :name="'sales_field'+sales_index" v-model="sales.value">
                                        <div class="row">
                                                <el-checkbox class="col-xl-4 col-lg-6 col-md-6 col-sm-6 w-150 text-capitalize d-flex word-wrap text-truncate" :title="check" @change="$forceUpdate()" :label="check" v-for="(check, option_index) in sales.options" :key="option_index">
                                                    {{check}}
                                                </el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'date_and_time' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 mt-2">
                                            <div class="w-100">
                                                <date-picker :name="'sales_field'+sales_index" @change="$forceUpdate()"
                                                    class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"
                                                    v-model="sales.date_value" value-type="format" lang="en" type="date" format="MM-DD-YYYY">
                                                </date-picker>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 mt-2 margin-top-res">
                                            <div class="w-100">
                                                <date-picker v-model="sales.time_value" :name="'sales_field'+sales_index" @change="$forceUpdate()"
                                                    class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                    format="hh:mm A" type="time" placeholder="Select Time" value-type="format"
                                                    lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                                    confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'date' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <date-picker :name="'sales_field'+sales_index"
                                            class="cal-icon date-input-customer calendar-edit-per input-field pt-0 pb-0 pr-0 mt-2"
                                            v-model="sales.value" value-type="format" lang="en" type="date"
                                            @change="$forceUpdate()" format="MM-DD-YYYY" :clearable="false">
                                        </date-picker>
                                    </div>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'radio_button' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100 mt-2">
                                        <el-radio-group v-model="sales.value" :name="'sales_field'+sales_index" v-for="(option,option_index) in sales.options"
                                            :key="option_index" class="w-200px">
                                            <el-radio class="ml-2 pt-2" @change="$forceUpdate()"
                                                :label="option" :id="option">{{option}}</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'time' && sales.is_required == false">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}
                                </span>
                                <div class="d-flex align-items-center mt-2">
                                    <div class="w-100">
                                        <date-picker v-model="sales.value" :name="'sales_field'+sales_index" @change="$forceUpdate()"
                                            class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                            format="hh:mm A" type="time" placeholder="Select Time" value-type="format"
                                            lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                            confirm-text="APPLY">
                                        </date-picker>
                                    </div>
                                </div>
                            </div>
                            <div v-if="sales.field_type == 'input_field' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize" >
                                    {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <input class="inputFieldNew mt-2" :maxlength="50" v-validate="{required:true}" :name="'sales_field'+sales_index" type="text" v-model="sales.value" :placeholder="'Enter ' + sales.field_name" />
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                            <div v-if="sales.field_type == 'dropdown_field' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect v-validate="{required:true}" :name="'sales_field'+sales_index"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                            :searchable="true" open-direction="bottom" @change="$forceUpdate()"
                                            v-model="sales.value" :max-height="200" label="" id="ajaxnew"
                                            :options="sales.options" :placeholder="'Select ' + sales.field_name" />
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">{{sales.field_name}} Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                            <div v-if="sales.field_type == 'amount' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}({{currency}})<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <input :name="'sales_field'+sales_index" class="inputFieldNew mt-2" v-on:keypress="isNumber($event)" :maxLength="15" autocomplete="off" type="text" v-validate="{ required: true, regex: /^-?\d+(?:\.\d?\d)?$/}" v-model="sales.value" placeholder="Enter Amount" />
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                            <div v-if="sales.field_type == 'checkbox' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex justify-content-between align-items-center px-2">
                                    <el-checkbox-group class="refund-checkbox mt-4 w-100" v-validate="'required'" :name="'sales_field'+sales_index" v-model="sales.value">
                                        <div class="row">
                                                <el-checkbox @change="$forceUpdate()" class="col-xl-4 col-lg-6 col-md-6 col-sm-6 w-150 text-capitalize d-flex word-wrap text-truncate" :title="check" :label="check" v-for="(check, option_index) in sales.options" :key="option_index">
                                                    {{check}}
                                                </el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                            <div v-if="sales.field_type == 'date_and_time' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="row">
                                        <div class="col-lg-7 col-md-6 col-sm-12 mt-2">
                                            <div class="w-100">
                                                <date-picker v-validate="{required:true}" @change="$forceUpdate()" :name="'sales_field'+sales_index"
                                                    class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"
                                                    v-model="sales.date_value" value-type="format" lang="en" type="date" format="MM-DD-YYYY">
                                                </date-picker>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-6 col-sm-12 mt-2 margin-top-res">
                                            <div class="w-100">
                                                <date-picker v-model="sales.time_value" @change="$forceUpdate()" v-validate="{required:true}" :name="'sales_field'+sales_index"
                                                    class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                    format="hh:mm A" type="time" placeholder="Select Time" value-type="format"
                                                    lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                                    confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                            <div v-if="sales.field_type == 'date' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <date-picker v-validate="{required:true}" :name="'sales_field'+sales_index"
                                            class="cal-icon date-input-customer calendar-edit-per input-field pt-0 pb-0 pr-0 mt-2"
                                            v-model="sales.value" value-type="format" lang="en" type="date"
                                            @change="$forceUpdate()" format="MM-DD-YYYY" :clearable="false">
                                        </date-picker>
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                            <div v-if="sales.field_type == 'radio_button' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100 mt-2">
                                        <el-radio-group v-model="sales.value" v-validate="'required'" :name="'sales_field'+sales_index" v-for="(option,option_index) in sales.options"
                                            :key="option_index" class="w-200px">
                                            <el-radio class="ml-2 pt-2" @change="$forceUpdate()"
                                                :label="option" :id="option">{{option}}</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                            <div v-if="sales.field_type == 'time' && sales.is_required == true">
                                <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                    {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center mt-2">
                                    <div class="w-100">
                                        <date-picker v-model="sales.value" @change="$forceUpdate()" v-validate="{required:true}" :name="'sales_field'+sales_index"
                                            class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                            format="hh:mm A" type="time" placeholder="Select Time" value-type="format"
                                            lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                            confirm-text="APPLY">
                                        </date-picker>
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                    {{sales.field_name}} is Required
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Buttons Section -->
            <div class="v-modal-footer mb-4 mt-2">
                <div class="d-flex  align-items-center justify-content-center ">
                    <button class="btn new-cancel-button mt-2" @click="hideAddSalesData()">Cancel</button>
                    <button class="btn new-save-button mt-2 ml-6" @click="saveSalesData">Save</button>
                </div>
                <!--<div v-else class="d-flex  align-items-center justify-content-center">
                    <button class="btn btn-des-small mt-2 btn-cancel-style" style="border: 1px solid transparent;color: #A6A6A6 !important;" disabled>Cancel</button>
                    <button class="btn btn-des-small mt-2 ml-6 btn-new-save" style="border: 1px solid transparent;position: relative;" disabled>Save
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div> -->
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
    </modal>
</template>
<script>
import { HollowDotsSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import { debounce } from 'lodash';
import productslist from '../mixins/products';
import { HalfCircleSpinner } from "epic-spinners";
export default {
    data(){
        return {
            template_details: {},
            warning_msg: '',
            success_msg: '',
            Product_name: "",
            template_loader: false,
            currency: "",
        }
    },
    props: ['modal_name', "product_data"],
    components: {SweetModal, HollowDotsSpinner, HalfCircleSpinner},
    mixins: [productslist],
    methods: {
        isNumber: (evt) =>  {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
                evt.preventDefault();
            else {
                if(index == 0){
                    if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 8)){
                        evt.preventDefault();
                    } else {
                        let number = evt.target.value.split('.')
                        if(number[1].length > 1){
                            evt.preventDefault();
                        }
                    }
                }
                else if (index > 0 && charCode == 46) {
                    evt.preventDefault();
                }
                if (index > 0) {
                    let number = evt.target.value.split('.')
                    if(number[1].length > 1){
                        evt.preventDefault();
                    }
                }
            }
        },
        async getProductData(){
            this.template_loader = true
            let params = {
                _id: this.product_data._id,
                edit: true
            }
            let response = await this.GetProductByID(params)
            let sales_template_details_data = response.response.result
            if(sales_template_details_data.sales_template_details == null){
                this.template_loader = false
            }else{
                let data_temp = sales_template_details_data.sales_template_details
                let fields_data = data_temp.fields
                this.template_details._id = sales_template_details_data.sales_template_id
                this.template_details.fields = fields_data
                this.template_details.fields.forEach(x => {
                    if(x.field_type == 'checkbox'){
                        x['value']= []
                    }else if(x.field_type == 'date_and_time'){
                        x['time_value']= ""
                        x['date_value']= ""
                    }else{
                        x['value'] = null
                    }
                })
                this.template_loader = false
            }
        },
        saveSalesData(){
            this.$validator.validateAll().then(async result => {
                let params = {
                    template_details : this.template_details
                }
                this.product_data.template_details = this.template_details
                // })
                if(result == true){
                    this.$emit('saveSalesData', this.product_data);
                    this.hideAddSalesData();
                }
            });
        },
        hideAddSalesData(){
            this.$modal.hide(this.modal_name)
            this.$emit('hideAddSalesModal')
        },
    },
    mounted(){
        this.currency = this.loggedInUser.currency.symbol;
        this.Product_name = this.product_data.name
        this.getProductData();
    },
    created() {
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    },
}
</script>
<style scoped>
    .btn-cancel-style {
        color: #E82828 !important;
        background-color: #fff;
        border: 1px solid #E82828
    }
    .btn-edit-delete-style {
        color: #E82828 !important;
        background-color: #fff;
        border: 1px solid #E82828;
        padding: 0px 0px !important;
        width: 60px !important;
        border-radius: 5px !important;
        font-size: 14px !important;
        line-height: 30px !important;
        text-transform: none !important;
        font-weight: 600 !important;
        cursor: pointer;
    }
    .btn-delete-style {
        color: #E82828 !important;
        background-color: #fff;
        border: 1px solid #E82828;
        width: 136px !important;
    }
    .btn-new-save {
        color: #fff;
        background-color: #1A9347;
    }
    .btn-edit-save {
        color: #fff;
        background-color: #1A9347 !important;
        border: 1px solid #1A9347 !important;
        padding: 0px 0px !important;
        width: 60px !important;
        border-radius: 5px !important;
        font-size: 14px !important;
        line-height: 30px !important;
        text-transform: none !important;
        font-weight: 600 !important;
        cursor: pointer;
    }
    .bg-color{
        background-color: #cce3fc;
        color:#0475f3 !important;
        padding: left 0px !important;
    }
    .disableBtn{
        background-color: rgb(133, 133, 133, 0.6) !important;
        border: none !important;
        pointer-events: none !important;
        color: #fff !important;
    }
    .product-box{
        width: 100%;
        height: 100%;
        padding: 5px 14px 25px 14px;
        object-fit: contain;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
        border-radius: 8px !important;
    }
    .minus-icon {
        width: 35px;
        height: 35px;
        padding: 6px 0 4.6px 7px;
        border-radius: 8px !important;
        box-shadow: 0 3px 6px 0 rgba(0, 68, 139, 0.31);
        background-color: #fff;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        font-size: 14px !important;
        font-weight: 600;
        color: #303031 !important;
    }
    .input-field::placeholder{
        color: #4e5764 !important;
		display: inline-block;
		margin-bottom: 7px !important;
		padding-top: 5px;
		padding-left: 5px !important;
		width: 100%;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
        font-weight: 400 !important;
    }
    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 90px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Deals/AddSaleData.vue